import { useQuery } from "@tanstack/react-query";
import { RouteIdEnum } from "config/enums";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import React, { useState } from "react";
import { FaCircleMinus } from "react-icons/fa6";
import {
  getAllPointOfSales,
  GetProductsBySupplier,
  getProviders,
} from "UpdatedFeatures/api";

const AddArrivage = () => {
  const [fournisseur, setFournisseur] = useState("");
  const [products, setProducts] = useState([]);
  const {
    data: productsSupplier,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["productsSupplier", fournisseur],
    queryFn: () => GetProductsBySupplier(fournisseur),
    enabled: !!fournisseur,
  });

  const { data: providers } = useQuery({
    queryKey: ["providers"],
    queryFn: () => getProviders(),
  });
  const { data: posData } = useQuery({
    queryKey: ["pointOfSales"],
    queryFn: () => getAllPointOfSales(),
  });

  const pointsOfSales = posData?.data || [];

  const handleFournisseurChange = (e) => {
    const selectedFournisseur = e.target.value;
    setFournisseur(selectedFournisseur);

    if (selectedFournisseur) {
      setProducts([
        {
          product: "",
          arrivageQty: "",
          prixAchat: "",
          codeBar: "",
          distribution: [
            { posId: "KD", posName: "KD Marche", qty: "" },
            ...pointsOfSales.map((pos) => ({
              posId: pos.id,
              posName: pos.name,
              qty: "",
            })),
          ],
        },
      ]);
    } else {
      setProducts([]);
    }
  };

  const addProductEntry = () => {
    setProducts((prev) => [
      ...prev,
      {
        product: "",
        arrivageQty: "",
        prixAchat: "",
        codeBar: "",
        distribution: [
          { posId: "KD", posName: "KD Marche", qty: "" },
          ...pointsOfSales.map((pos) => ({
            posId: pos.id,
            posName: pos.name,
            qty: "",
          })),
        ],
      },
    ]);
  };

  const removeProductEntry = (index) => {
    setProducts((prev) => prev.filter((_, i) => i !== index));
  };

  const updateProductField = (index, field, value) => {
    setProducts((prev) =>
      prev.map((product, i) =>
        i === index ? { ...product, [field]: value } : product
      )
    );
  };

  const updateDistributionQty = (productIndex, posId, value) => {
    setProducts((prev) =>
      prev.map((product, i) =>
        i === productIndex
          ? {
              ...product,
              distribution: product.distribution.map((dist) =>
                dist.posId === posId ? { ...dist, qty: value } : dist
              ),
            }
          : product
      )
    );
  };

  const handleSubmit = () => {
    const payload = {
      fournisseur,
      products,
    };
    console.log("Payload:", payload);
  };

  return (
    <DashboardLayout title="Arrivage" selectedPath={RouteIdEnum.Stock}>
      <div className="flex w-full justify-between items-center mb-6">
        <div className="flex-1">
          <label
            htmlFor="fournisseur"
            className="block text-lg font-semibold text-gray-700"
          >
            Fournisseur
          </label>
          <select
            id="fournisseur"
            value={fournisseur}
            onChange={handleFournisseurChange}
            className="w-full mt-2 p-2 border border-purple-300 focus:border-purple-400 focus:ring-offset-1 focus:ring-offset-1-offset-purple-400 rounded-md"
          >
            <option value="">Choisissez un fournisseur</option>
            {providers?.data?.map((provider) => (
              <option key={provider.id} value={provider.id}>
                {provider.company_name}
              </option>
            ))}
          </select>
        </div>
        <div className="ml-6 flex-1">
          <label
            htmlFor="date"
            className="block text-lg font-semibold text-gray-700"
          >
            Date
          </label>
          <input
            id="date"
            type="date"
            value={new Date().toISOString().split("T")[0]}
            className="w-full mt-2 p-2 border border-purple-300 focus:border-purple-400 focus:ring-offset-1 focus:ring-offset-1-offset-purple-400  rounded-md"
            disabled
          />
        </div>
      </div>

      {fournisseur && isLoading && <p>Loading products...</p>}
      {fournisseur && error && <p>Error loading products</p>}

      {fournisseur &&
        products.map((product, index) => (
          <div
            key={index}
            className="bg-white pt-12 relative w-full max-w-5xl p-6 border border-gray-300 rounded-3xl shadow-md mb-6"
          >
            <FaCircleMinus
              className="text-red-500 absolute top-5 right-10 cursor-pointer hover:text-red-400"
              size={26}
              onClick={() => removeProductEntry(index)} // Handle click to remove specific product
            />
            <div className="grid grid-cols-3 gap-4 mb-4">
              <div>
                <label
                  htmlFor={`product-${index}`}
                  className="block text-lg font-semibold text-gray-700"
                >
                  Produit
                </label>
                <select
                  id={`product-${index}`}
                  value={product.product}
                  onChange={(e) =>
                    updateProductField(index, "product", e.target.value)
                  }
                  className="w-full mt-2 p-2 border border-purple-300 focus:border-purple-400 focus:ring-offset-1 focus:ring-offset-1-offset-purple-400  rounded-md"
                >
                  <option value="">Choisissez un produit</option>
                  {productsSupplier?.map((prod) => (
                    <option key={prod.id} value={prod.id}>
                      {prod.title}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label
                  htmlFor={`prixAchat-${index}`}
                  className="block text-lg font-semibold text-gray-700"
                >
                  Prix d'achat
                </label>
                <input
                  id={`prixAchat-${index}`}
                  type="number"
                  value={product.prixAchat}
                  onChange={(e) =>
                    updateProductField(index, "prixAchat", e.target.value)
                  }
                  className="w-full mt-2 p-2 border border-purple-300 focus:border-purple-400 focus:ring focus:ring-purple-400 focus:ring-offset-1 rounded-md"
                />
              </div>
              <div>
                <label
                  htmlFor={`codeBar-${index}`}
                  className="block text-lg font-semibold text-gray-700"
                >
                  Code bar
                </label>
                <input
                  id={`codeBar-${index}`}
                  type="text"
                  value={product.codeBar}
                  onChange={(e) =>
                    updateProductField(index, "codeBar", e.target.value)
                  }
                  className="w-full mt-2 p-2 border border-purple-300 focus:border-purple-400 focus:ring-offset-1 focus:ring-offset-1-offset-purple-400  rounded-md"
                />
              </div>
            </div>

            <h3 className="text-lg font-semibold text-gray-700 mb-4">
              Répartition
            </h3>
            <div className="grid grid-cols-2 gap-4">
              {product.distribution.map(({ posId, posName, qty }) => (
                <div key={posId}>
                  <label
                    htmlFor={`dist-${index}-${posId}`}
                    className="block text-md font-medium text-gray-700"
                  >
                    {posName}
                  </label>
                  <input
                    id={`dist-${index}-${posId}`}
                    type="number"
                    value={qty}
                    onChange={(e) =>
                      updateDistributionQty(index, posId, e.target.value)
                    }
                    className="w-full mt-2 p-2 border border-purple-300 focus:border-purple-400 focus:ring-offset-1 focus:ring-offset-1-offset-purple-400  rounded-md"
                  />
                </div>
              ))}
            </div>
          </div>
        ))}

      {fournisseur && (
        <div className="flex justify-end gap-4">
          <button
            onClick={addProductEntry}
            className="text-white bg-[#b269ae] hover:bg-[#9c58a3] px-4 py-2 rounded-md"
          >
            +
          </button>
        </div>
      )}

      {products.length > 0 && (
        <button
          onClick={handleSubmit}
          className="mt-4 text-green-700 border border-green-600 bg-green-600/30 hover:bg-green-500/30 px-4 py-2 rounded-md"
        >
          Sauvegarder l'arrivage
        </button>
      )}
    </DashboardLayout>
  );
};

export default AddArrivage;
